import React from "react";
import { Link } from "react-router-dom";
import newsItems from "../../../data/newsItems";
import {
  FaArrowRight,
  FaBookOpen,
  FaCompass,
  FaGraduationCap,
  FaHeart,
  FaLaptop,
  FaPhoneAlt,
  FaSchool,
  FaUsers,
} from "react-icons/fa";
import Banner4 from "../../image/Banner4.jpg";
import CampusBuilding from "../../image/schoolBuilding.png";
import CampusMoment from "../../image/IMG_0180.JPG";
import EventMoment from "../../image/_MG_7488[1].jpg";
import Kd1 from "../../image/kd1.jpg";
import Hero from "./Hero";
import { getPortalLink } from "../../../utils/portalLinks";

// Place any data arrays here if needed (highlights, pathways, etc.)

function Home() {
  const educatorPortalLink = getPortalLink("educator");
  const studentPortalLink = getPortalLink("student");
  const parentPortalLink = getPortalLink("parent");

  return (
    <>
      {/* Hero Section */}
      <Hero />

      {/* Portal Login Links Section */}
      <section className="bg-[#f7f3ea] py-10 text-slate-900">
        <div className="mx-auto w-full max-w-4xl px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-[#102046]">Access the Portal</h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={educatorPortalLink}
              className="rounded-full bg-[#102046] px-8 py-4 text-base font-bold uppercase tracking-wide text-white transition hover:bg-[#17305e] shadow-md"
            >
              Educator Portal
            </a>
            <a
              href={studentPortalLink}
              className="rounded-full bg-[#d4a448] px-8 py-4 text-base font-bold uppercase tracking-wide text-slate-900 transition hover:bg-[#e2b65f] shadow-md"
            >
              Student Portal
            </a>
            <a
              href={parentPortalLink}
              className="rounded-full bg-[#cf1020] px-8 py-4 text-base font-bold uppercase tracking-wide text-white transition hover:bg-[#e23a4a] shadow-md"
            >
              Parent Portal
            </a>
          </div>
        </div>
      </section>

      {/* School Life Section */}
      <section className="bg-white py-20 text-slate-900">
        <div className="mx-auto w-full max-w-6xl px-6">
          <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <h2 className="text-4xl md:text-5xl font-bold mb-4">A diverse, multicultural population</h2>
              <p className="text-base text-slate-700 mb-6">We have a diverse, multicultural population covering various ethnic groups and nationalities within the West African sub-region and beyond. Discover the vibrant daily life at S-TEE Schools, where students grow together beyond the classroom.</p>

            </div>
            <img src={CampusMoment} alt="School Life" className="rounded-2xl w-full h-80 object-cover lg:w-1/2" />
          </div>
        </div>
      </section>

      {/* Academics Section */}
      <section className="bg-[#f7f3ea] py-20 text-slate-900">
        <div className="mx-auto w-full max-w-6xl px-6">
          <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            <img src={Banner4} alt="Academics" className="rounded-2xl w-full h-80 object-cover lg:w-1/2 order-2 lg:order-1" />
            <div className="max-w-2xl order-1 lg:order-2">
              <h2 className="text-4xl md:text-5xl font-bold mb-4">World-class education in Festac Town</h2>
              <p className="text-base text-slate-700 mb-4">Admission into various classes for the 2025/2026 academic session is now open to prospective candidates. At S-TEE Schools, we pride ourselves as the best school in Festac Town, delivering quality, world-class education with a view of developing excellence in our learners.</p>

            </div>
          </div>
        </div>
      </section>

      {/* Events Section */}
      <section className="bg-white py-20 text-slate-900">
        <div className="mx-auto w-full max-w-6xl px-6">
          <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <h2 className="text-4xl md:text-5xl font-bold mb-4">Strategic paths to excellence</h2>
              <p className="text-base text-slate-700 mb-6">All our activities and events are strategic paths to excellence in our learners. See how our events help raise standards and push boundaries for every student.</p>

            </div>
            <img src={EventMoment} alt="Events" className="rounded-2xl w-full h-80 object-cover lg:w-1/2" />
          </div>
        </div>
      </section>

      {/* School Video Tour Section */}
      <section className="bg-[#102046] py-20 text-white">
        <div className="mx-auto w-full max-w-4xl px-6 text-center">
          <p className="text-xs uppercase tracking-[0.35em] text-amber-200">School Video Tour</p>
          <h2 className="mt-4 text-4xl md:text-5xl">Take a tour of S-TEE</h2>
          <p className="mt-5 text-base text-slate-200/80 md:text-lg">This video is a snippet of how our events are staged. See the best school in the State.</p>
          <div className="mt-10 flex justify-center">
            <a href="https://youtu.be/X1wTL16dCyE" target="_blank" rel="noopener noreferrer" className="inline-block rounded-full bg-[#d4a448] px-7 py-4 text-xs font-bold uppercase tracking-[0.22em] text-slate-900 transition hover:bg-[#e2b65f]">Watch Video Tour</a>
          </div>
        </div>
      </section>

      {/* News & Updates Section */}
      <section className="bg-white py-20 text-slate-900">
        <div className="mx-auto w-full max-w-6xl px-6">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-2xl">
              <p className="text-xs uppercase tracking-[0.35em] text-[#8a6a33]">School News & Updates</p>
              <h2 className="mt-4 text-4xl md:text-5xl">Latest Announcements</h2>
            </div>
            <p className="max-w-xl text-base text-slate-600 md:text-lg">Stay up to date with the latest news, events, and updates from S-TEE Schools.</p>
          </div>
          <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {newsItems.map((item, idx) => {
              // Assign a thumbnail image for each news item (placeholder logic)
              let thumbnail = require("../../image/Banner4.jpg");
              let alt = "News Thumbnail";
              if (item.date === "February 6, 2023" && item.title.includes("DARK WEB")) {
                thumbnail = require("../../image/_MG_7488[1].jpg");
                alt = "Dark Web: Managing Gadgets";
              } else if (item.date === "January 28, 2026") {
                thumbnail = require("../../image/schoolBuilding.png");
                alt = "Admissions Open";
              } else if (item.date === "September 4, 2025") {
                thumbnail = require("../../image/IMG_0180.JPG");
                alt = "Back to School";
              }
              return (
                <div key={item.path} className="block rounded-2xl border border-[#e6dcc8] bg-[#fffdfa] p-6 shadow-md hover:shadow-lg transition">
                  <div className="flex flex-row items-start gap-4">
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
                      {item.summary && <p className="text-sm text-slate-700 mb-2">{item.summary}</p>}
                      <span className="text-xs text-[#cf1020]">{item.date}</span>
                      <div className="mt-2 text-xs text-slate-500">By {item.author}</div>
                      <div className="mt-4">
                        <Link to={item.path} className="inline-block text-[#102046] font-semibold hover:underline text-sm">Read More</Link>
                      </div>
                    </div>
                    <img
                      src={thumbnail}
                      alt={alt}
                      className="w-24 h-24 object-cover rounded-xl border border-[#e6dcc8] hidden md:block"
                      style={{ minWidth: 96 }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Subscribe To Newsletter Section (moved here) */}
      <section className="bg-[#f7f3ea] py-16 border-b border-[#e6dcc8]">
        <div className="mx-auto w-full max-w-xl px-6 text-center flex flex-col items-center">
          <div className="mb-4 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-[#102046]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold mb-2 text-[#102046]">Subscribe To Newsletter</h2>
          <p className="text-base text-slate-700 mb-2">Get updates to news & events</p>
          <p className="text-sm text-slate-600 mb-6">Our Charity Day is the single largest which presents the one opportunity to give back. Join Us!</p>
          <form action="https://formspree.io/f/mwkgyyqg" method="POST" className="flex flex-col sm:flex-row gap-3 w-full max-w-md mx-auto">
            <input type="email" name="email" placeholder="Your email address" className="flex-1 px-4 py-3 rounded-full border border-[#e6dcc8] focus:outline-none focus:ring-2 focus:ring-[#102046]" required />
            <button type="submit" className="rounded-full bg-[#102046] px-6 py-3 text-xs font-bold uppercase tracking-[0.22em] text-white transition hover:bg-[#17305e]">Subscribe</button>
          </form>
        </div>
      </section>
    </>
  );
}

export default Home;
